import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { WindowRef } from '@x/common/browser';
import { ChannelContextService } from '@x/ecommerce-shop/app/channel/services/channel-context.service';
import { IChannelSelectOption } from '@x/ecommerce-shop/app/channel/state/channel.state';
import { RoutingContextService } from '@x/ecommerce-shop/app/core/routing/routing-context.service';

@Component({
  selector: 'x-channel-gateway',
  templateUrl: './channel-gateway.component.html',
  styleUrls: ['./channel-gateway.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'x-channel-gateway' },
})
export class ChannelGatewayComponent {
  channelsOptions$ = this.channelContextService.channelPickerOptions$;

  constructor(
    private router: Router,
    public rc: RoutingContextService,
    private windowRef: WindowRef,
    private channelContextService: ChannelContextService,
  ) {}

  gotoChannel(channel: IChannelSelectOption) {
    const { code, url } = channel;
    if (url) {
      this.windowRef.document.location.href = url;
      return;
    }
    this.router.navigate([`/${code}`], {
      queryParamsHandling: 'preserve',
    });
  }
}
